// extracted by mini-css-extract-plugin
export default {"container":"VQrCodeCard_container__m4uXY","text":"VQrCodeCard_text__qP8RE"};